import type { DefaultValues } from "react-hook-form"
import { UserForm } from "../UserForm"
import type { FormValues } from "../UserForm/UserForm.component"
import { formDefaults } from "../UserForm/tabs/GeneralInfos/GeneralInfos.default"

const defaultValues = {
  ...formDefaults,
}

export function CreateUser() {
  return <UserForm defaultValues={defaultValues} />
}

const myUserDefaultValues: DefaultValues<FormValues> = {
  ...defaultValues,
  type: "TEAM",
  status: "ACTIVE",
}

export function CreateMyUser() {
  return <UserForm defaultValues={myUserDefaultValues} />
}
